import { forwardRef, Inject, Pipe, PipeTransform } from '@angular/core';
import { AuthenticationService } from '../../service/authentication.service';
import { ServitlyBadgePipe } from './servitly-badge.pipe';

@Pipe({ name: 'alertSeverity' })
export class AlertSeverityPipe implements PipeTransform {

    constructor(
        @Inject(forwardRef(() => AuthenticationService)) private authenticationService: AuthenticationService,
        @Inject(forwardRef(() => ServitlyBadgePipe)) private syBadgePipe: ServitlyBadgePipe
    ) {
    }

    transform(value: string): string {
        if (this.authenticationService.isNewStyleManagerEnabled()) {
            return this.syBadgePipe.transform(value, { colorTokenPrefix: 'severities', showLeadingIcon: false });
        }
        switch (value) {
            case 'EMERGENCY':
                return this.getSeverityIcon('fa-exclamation-circle', '#dd4b39', value);
            case 'FAILURE':
            case 'CRITICAL':
                return this.getSeverityIcon('fa-exclamation-triangle', '#dd4b39', value);
            case 'WARNING':
                return this.getSeverityIcon('fa-exclamation-triangle', '#f39c12', value);
            case 'INFORMATIONAL':
                return this.getSeverityIcon('fa-exclamation-triangle', '#00a65a', value);
            default:
                return value;
        }
    }

    getSeverityIcon(icon: string, color: string, severity: string): string {
        return `<i class="fas ${icon}" style="color: ${color}" title="${severity}"></i>`
    }
}

